module.exports = __webpack_public_path__ + "img/shot_img112003.c79eb0f0.gif";